/// <amd-module name="Release/DeploymentsSection/SignalRHub" />
import { DeploymentsSignalRActionCreator } from "Release/DeploymentsSection/Actions/SignalR";
import {
    HubNames,
    IReleaseDetailHubServer,
    IReleaseDetailHubClient,
    getReleaseProxyToRegister
} from "Release/SignalR/SignalRHubProxies";

import {
    SignalRHub,
    IHubHostInformation,
    IHubListener
} from "VSS/Features/SignalR/Hub";
import { ISignalRHubProxy } from "VSS/Features/SignalR/HubProxies.types";
import { EnvironmentStatus, DeploymentStatus, DeploymentOperationStatus } from "Release/Client/Contracts/Release";

import * as Utils_String from "VSS/Core/Util/String";

export interface IDeploymentsSignalRHubOptions {
    hostInformation: IHubHostInformation;
    projectId: string;
    actionCreator: DeploymentsSignalRActionCreator;
    listener?: IHubListener;
}

export class DeploymentsSignalRHub extends SignalRHub<IReleaseDetailHubClient, IReleaseDetailHubServer> {
    private _options: IDeploymentsSignalRHubOptions;
    public watchedReleases: Set<string>;

    public static s_userInactivityTimeoutMs = 1 * 60 * 60 * 1000; // 1 hour

    constructor(options: IDeploymentsSignalRHubOptions) {
        super({
            hostInformation: options.hostInformation,
            name: HubNames.releaseHub,
            listener: options.listener || new DeploymentsSignalRHubListener(options.actionCreator),
            userInactivityTimeoutMs: DeploymentsSignalRHub.s_userInactivityTimeoutMs
        });

        this._options = options;
        this.watchedReleases = new Set();
        this.initializeProxy(getReleaseProxyToRegister, this._initializeClient);
    }

    public watchRelease(projectId: string, releaseId: number) {
        var releaseIndex = Utils_String.format("{0}/{1}", projectId, releaseId);
        if (this.watchedReleases.has(releaseIndex)) {
            return;
        }
        
        this.start().then(() => {
            const hub = this.hub;
            if (hub) {
                hub.server.watchRelease(projectId, releaseId).then(() => {
                    console.log("DeploymentsSignalRHub: watching release " + releaseId);
                    this.watchedReleases.add(releaseIndex);
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    public stopWatchingRelease(projectId: string, releaseId: number) {
        const hub = this.hub;
        var releaseIndex = Utils_String.format("{0}/{1}", projectId, releaseId);
        if (hub && this.watchedReleases.has(releaseIndex)) {
            hub.server.stopWatchingRelease(projectId, releaseId);
            console.log("DeploymentsSignalRHub: Stopped watching release " + releaseId);
            this.watchedReleases.delete(releaseIndex);
        }
    }

    private _initializeClient = (proxy: ISignalRHubProxy<IReleaseDetailHubClient, IReleaseDetailHubServer>) => {
        proxy.client.onReleaseEnvironmentStatusUpdated = (projectId: string, definitionId: number, releaseId: number, environmentId: number, environmentStatus: EnvironmentStatus, deploymentStatus: DeploymentStatus, deploymentOperationStatus: DeploymentOperationStatus) => {
            this._options.actionCreator.environmentUpdated(projectId, definitionId, releaseId, environmentId, environmentStatus, deploymentStatus, deploymentOperationStatus);
        };
    }
}

class DeploymentsSignalRHubListener implements IHubListener {
    private _actionCreator: DeploymentsSignalRActionCreator;
    private _isDisconnectivityTriggered: boolean = false;
    private _isUserInactivityTriggered: boolean = false;

    constructor(actionCreator: DeploymentsSignalRActionCreator) {
        this._actionCreator = actionCreator;
    }

    isConnecting(): void {

    }

    isConnected(): void {

    }

    isDisconnected(): void {
        if (!this._isUserInactivityTriggered && !this._isDisconnectivityTriggered) {
            this._isDisconnectivityTriggered = true;
        }
    }

    isReconnected(): void {

    }

    isReconnecting(): void {

    }

    isSlow(): void {

    }

    isUserActive(): void {

    }

    isUserInactive(): void {
        if (!this._isDisconnectivityTriggered) {
            this._isUserInactivityTriggered = true;
        }
    }
}